import React from 'react'
import { Link, useForm, usePage } from '@inertiajs/inertia-react'
import AlertDismissible from '../../../Shared/Components/AlertDismissible'
import Breadcrumbs from '../../../Shared/Components/Breadcrumbs'
import Layout from '../../../Shared/Layout/LayoutAdmin'
import PaginationList from '../../../Shared/Components/PaginationList'
import Row from 'react-bootstrap/Row'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'
import Badge from 'react-bootstrap/Badge'

const StatusCatalogIndex = ({ items, filters, reportBucketLabels }) => {
    const { flash } = usePage().props
    const data = items.data || []

    const filterForm = useForm({
        search: filters.search || '',
    })

    const submitFilters = (e) => {
        e.preventDefault()
        filterForm.get(route('secom.catalogs.index'), { preserveState: true })
    }

    const clearFilters = () => {
        filterForm.setData({ search: '' })
        filterForm.get(route('secom.catalogs.index'))
    }

    return (
        <Row>
            {flash?.success && <AlertDismissible message={flash.success} type="success" />}
            <span className="pb-7 pt-7">
                <Breadcrumbs currentPath="admin/secom/catalogos/status" />
            </span>

            <div className="card card-flush h-md-100">
                <div className="card-header pt-7">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label fw-bold text-gray-800">SECOM — Catálogo de status</span>
                    </h3>
                    <div className="card-toolbar">
                        <Link href={route('secom.catalogs.create')} className="btn btn-sm btn-primary">
                            <i className="bi bi-plus-lg me-1" />
                            Nuevo status
                        </Link>
                    </div>
                </div>

                <div className="card-body pt-6">
                    <Form onSubmit={submitFilters} className="d-flex flex-wrap align-items-end gap-3 mb-8">
                        <div className="flex-grow-1" style={{ minWidth: '220px', maxWidth: '420px' }}>
                            <label className="form-label fs-7 fw-bold text-gray-600 mb-2">Buscar</label>
                            <Form.Control
                                type="search"
                                className="form-control form-control-sm form-control-solid"
                                placeholder="Nombre…"
                                value={filterForm.data.search}
                                onChange={(e) => filterForm.setData('search', e.target.value)}
                            />
                        </div>
                        <Button type="submit" size="sm" variant="primary" disabled={filterForm.processing}>
                            Buscar
                        </Button>
                        <Button type="button" size="sm" variant="light" onClick={clearFilters}>
                            Limpiar
                        </Button>
                    </Form>

                    <Table responsive hover className="align-middle">
                        <thead className="text-gray-600 fw-bold fs-7 text-uppercase">
                            <tr>
                                <th>Nombre</th>
                                <th>Agrupación en reporte</th>
                                <th>Orden</th>
                                <th>Activo</th>
                                <th className="text-end">Acciones</th>
                            </tr>
                        </thead>
                        <tbody className="fs-7">
                            {data.length === 0 ? (
                                <tr>
                                    <td colSpan={5} className="text-center text-muted py-10">
                                        Sin registros.
                                    </td>
                                </tr>
                            ) : (
                                data.map((item) => (
                                    <tr key={item.id}>
                                        <td className="fw-semibold">{item.name}</td>
                                        <td>{reportBucketLabels[item.report_bucket] || item.report_bucket}</td>
                                        <td>{item.sort_order}</td>
                                        <td>
                                            {item.activo ? (
                                                <Badge bg="success">Sí</Badge>
                                            ) : (
                                                <Badge bg="secondary">No</Badge>
                                            )}
                                        </td>
                                        <td className="text-end">
                                            <Link
                                                href={route('secom.catalogs.edit', item.id)}
                                                className="btn btn-sm btn-light-primary"
                                            >
                                                <i className="bi bi-pencil me-1" />
                                                Editar
                                            </Link>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>

                    <PaginationList links={items.links} filters={filters} />
                </div>
            </div>
        </Row>
    )
}

StatusCatalogIndex.layout = (page) => <Layout title="SECOM — Catálogo de status">{page}</Layout>

export default StatusCatalogIndex
